// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__Nyj+0","wrap":"Layout_wrap__vmT20","content":"Layout_content__vNjvJ"};